module.exports = __webpack_public_path__ + "img/pfeasy_app_download.ca7f6961.png";